// extracted by mini-css-extract-plugin
export default {"orderBodyGrid":"UsersOrder_orderBodyGrid__qRXy4"};